import React, { Fragment, useState } from 'react';
import { Button, Form, Alert, Col, Row, Container, Accordion, Table } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import RhService from '../../../../services/rh';



const FormCadHolerite = () => {
    const [arquivo, setArquivo] = useState("");
    const [mes, setMes] = useState("");
    const [ano, setAno] = useState("");
    const [error, setError] = useState([]);
    const [sucesso, setSucesso] = useState(false);
    const [result, setResult] = useState({ detalhes: [] });
    const [loading, setLoading] = useState(false);


    const handleUpload = (e) => setArquivo(e.target.files[0]);

    const montaForm = async () => {
        const holerite = new FormData();
        holerite.append("referenciaMes", mes);
        holerite.append("referenciaAno", ano);
        holerite.append("arquivo", arquivo);
        return holerite
    }

    const HandleSubmit = async (evt) => {
        evt.preventDefault();
        setLoading(true);
        setError([]);
        setSucesso(false);

        const dados = await montaForm();

        try {
            const hol = await RhService.cadastroHolerite(dados);
            setLoading(false);

            const resposta = hol.data;

            if (resposta.total_processados > 0) {
                setSucesso(true);
                setResult(resposta);
            } else {
                setError(resposta.detalhes || []);
            }

        } catch (error) {
            setLoading(false);

            // erro vindo da API
            if (error.response?.data) {
                setError([{ erro: error.response.data.erro }]);
            } else {
                setError([{ erro: "Erro inesperado ao enviar holerites" }]);
            }
        }
    };

    if (loading) {
        return (
            <Container className="text-center mt-5">
                <div className="d-flex justify-content-center">
                    <div className="spinner-border" role="status" />
                </div>
                <p className="mt-3">⏳ Lançando holerites, aguarde...</p>
            </Container>
        );
    }

    if (!sucesso) {
        return (
            <Fragment>
                <Container>
                    <Row xs={1}>
                        <Form onSubmit={HandleSubmit} >
                            <Row xs={1} lg={3}>
                                <Col xs={12} lg={3}>
                                    <Form.Group controlId="selectMes">
                                        <Form.Label>Mês</Form.Label>
                                        <Form.Select required value={mes} onChange={e => setMes(e.target.value)}>
                                            <option value="">SELECIONE</option>
                                            <option value="01">Janeiro</option>
                                            <option value="02">Fevereiro</option>
                                            <option value="03">Março</option>
                                            <option value="04">Abril</option>
                                            <option value="05">Maio</option>
                                            <option value="06">Junho</option>
                                            <option value="07">Julho</option>
                                            <option value="08">Agosto</option>
                                            <option value="09">Setembro</option>
                                            <option value="10">Outubro</option>
                                            <option value="11">Novembro</option>
                                            <option value="12">Dezembro</option>
                                            <option value="13">13º Salário - 1ª Parcela</option>
                                            <option value="14">13º Salário - 2ª Parcela</option>
                                            <option value="15">Informe Anual de Rendimentos</option>
                                        </Form.Select>
                                    </Form.Group>
                                </Col>
                                <Col xs={12} lg={3}>
                                    <Form.Group className="mb-3" controlId="ano">
                                        <Form.Label>Ano</Form.Label>
                                        <Form.Control
                                            required
                                            type="number"
                                            name="ano"
                                            value={ano}
                                            onChange={e => setAno(e.target.value)} />
                                    </Form.Group>
                                </Col>
                                <Col lg={6}>
                                    <Form.Group className="mb-3" controlId="arquivo">
                                        <Form.Label>Arquivo da Holerite Completa</Form.Label>
                                        <Form.Control
                                            required
                                            type="file"
                                            name="arquivo"
                                            onChange={handleUpload}
                                            accept="application/pdf"

                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                {error.length >= 1 ? <Alert variant="danger"> {[...error]}</Alert> : ''}
                                <Col xs={12} lg={3}>
                                    <Button variant="success" className="alinha-botao" type="submit">
                                        Cadastrar
                                    </Button>
                                </Col>
                            </Row>
                            <br/>
                            {error && error.length > 0 && (
                                <Alert variant="danger">
                                    <br/>
                                    <ul>
                                        {error.map((item, index) => (
                                            <li key={index}>
                                                {item.erro}
                                            </li>
                                        ))}
                                    </ul>
                                </Alert>
                            )}
                        </Form >
                    </Row>
                    <br/>
                    <Link to={'/rh/holerites'}>
                        <Button variant="danger" type="button">
                            Voltar
                        </Button>
                    </Link>
                    <br />
                </Container>
            </Fragment >
        )
    } else {
        return (
            <Fragment>
                <Container>
                    <Alert variant='success'>
                        Holerites cadastradas com sucesso!
                        Foram cadastrados {result.total_processados} holerites no sistema!
                    </Alert>
                    <Accordion defaultActiveKey="0" className="mt-4">
                        <Accordion.Item eventKey="0">
                            <Accordion.Header>Lista de Holerites lançados</Accordion.Header>
                            <Accordion.Body>
                                <Table striped bordered hover size="sm">
                                    <thead>
                                        <tr>
                                            <th>#</th>
                                            <th>Matrícula</th>
                                            <th>Nome</th>
                                            <th>Mensagem</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {result?.detalhes?.map((item, index) => (
                                            <tr
                                                key={index}
                                                className={item.situacao === "ERRO" ? "table-danger" : "table-success"}
                                            >
                                                <td>{index + 1}</td>
                                                <td>{item.matricula}</td>
                                                <td>{item.funcionario || "-"}</td>
                                                <td>{item.mensagem || "-"}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            </Accordion.Body>
                        </Accordion.Item>
                    </Accordion>
                    <br /><br />
                    <Link to={'/rh/holerites'}>
                        <Button variant="danger" type="button">
                            Voltar
                        </Button>
                    </Link>
                </Container>
            </Fragment>
        )
    }
}

export default FormCadHolerite;